export default __webpack_public_path__ + "static/media/eye.8cc20af5.svg";